import { useQuery } from "@tanstack/react-query";
import { apiConfig } from "../utils/apiConfig";
import logger from '../utils/logger';

// Reference data query
export const useReferenceData = () => {
  return useQuery({
    queryKey: ["referenceData"],
    queryFn: async () => {
      const response = await apiConfig.api.get(
        "/advisor-portal/reference-data",
      );
      return response.data;
    },
    staleTime: 24 * 60 * 60 * 1000, // Cache for 24 hours
    gcTime: 30 * 60 * 60 * 1000, // Keep in cache for 30 hours
  });
};

// Annual review data query
export const useAnnualReviewData = (householdId, year, version, isDemoMode = false) => {
  return useQuery({
    queryKey: ["annualReview", householdId, year, version],
    queryFn: async () => {
      logger.info("Fetching annual review data:", {
        householdId,
        year,
        version,
      });
      const response = await apiConfig.api.get(
        `/advisor-portal/client-database/household-profile/${householdId}/ar-profile/${year}/${version}`,
      );
      logger.info("Annual review data response:", response.data);
      return response.data;
    },
    enabled: Boolean(householdId && year && version),
  });
};

// Tax data query
export const useTaxData = () => {
  return useQuery({
    queryKey: ["taxData"],
    queryFn: async () => {
      const response = await fetch("/data/taxData.json");
      if (!response.ok) {
        throw new Error(`Failed to fetch tax data: ${response.status} ${response.statusText}`);
      }
      return response.json();
    },
    staleTime: 24 * 60 * 60 * 1000, // Cache for 24 hours
    gcTime: 30 * 60 * 60 * 1000, // Keep in cache for 30 hours
  });
};
